export default import.meta.ROLLDOWN_FILE_URL_$oUiuAXR7gZMKRQU56HW2w_d791b65b62362c4341d71ed2